import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Root from '@components/root/Root'
import Button from '@components/button/Button'
import SimpleAlert from '@components/modal/SimpleAlert'

import Info from './form/Info'

import useI18n from '@i18n/useI18n'
import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'

import useNavigation from '@layout/useNavigation'

import api from '@api/api'

import logger from '@utils/logger'

const AccountInfoScreen = () => {
  const user = useReducer(UserStore.store, (s) => s.user)

  // screen available only for connected user
  if (!user) {
    return null
  }

  return <Screen user={user} />
}

interface Props {
  user: UserResponse
}

const Screen = ({ user }: Props) => {
  const i18n = useI18n()
  const navigation = useNavigation()

  const [form, setForm] = React.useState<UserUpdateRequest>({
    prenom: user.prenom,
    nom: user.nom,
    numeroTelephone: user.numeroTelephonePortable,
    fonction: user.fonction,
    langage: user.langage,
  })

  const [status, setStatus] = React.useState<Status>('loading')
  const [sending, setSending] = React.useState(false)

  React.useEffect(() => {
    api.users
      .me()
      .then((me) => {
        UserStore.actions.setUser(me)
      })
      .catch(logger.error)
      .finally(() => setStatus('fetched'))
  }, [])

  const onSave = () => {
    setSending(true)
    api.users
      .updateUser(form)
      .then((newUser) => {
        // save to store
        UserStore.actions.setUser(newUser)

        SimpleAlert.open({
          title: i18n.t('common.success'),
          description: i18n.t('screens.account.success'),
          buttons: [
            {
              label: i18n.t('common.ok'),
              onClick: () => {
                SimpleAlert.close()
                navigation.goBack()
              },
            },
          ],
        })
      })
      .catch((err) => {
        logger.error(err)
        SimpleAlert.open({
          title: i18n.t('common.errorTitle'),
          description: i18n.t('common.error'),
          buttons: [{ label: i18n.t('common.ok'), onClick: () => SimpleAlert.close() }],
        })
      })
      .finally(() => setSending(false))
  }

  const onForm = (vals: UserUpdateRequest) => {
    setForm(vals)
    return Promise.resolve()
  }

  const renderFooter = () => (
    <Footer>
      <Button label={i18n.t('screens.account.mobileSave')} onClick={onSave} status={sending ? 'loading' : 'active'} />
    </Footer>
  )

  return (
    <Root
      loading={status === 'loading'}
      onLeft={navigation.goBack}
      header={i18n.t('screens.account.mobileSections.info')}
      renderFixedBottom={renderFooter}>
      <Info form={form} onChange={onForm} user={user} />
    </Root>
  )
}

export default AccountInfoScreen

const Footer = styled(View)`
  margin: 16px;
`
